// extracted by mini-css-extract-plugin
module.exports = {"col1":"single-column-col1__1mKjS"};